import React, { Fragment } from "react";

import PerfectScrollbar from "react-perfect-scrollbar";

import {
  DropdownToggle,
  DropdownMenu,
  Button,
  UncontrolledButtonDropdown,
} from "reactstrap";

import "react-toastify/dist/ReactToastify.css";
import { AuthClient } from "../../../web-api-client";
import { tokenStore } from "../../../utils/tokenStore";
import { parseJwt } from "../../../auth/jwtUtils";
import { appConfig } from "../../../appconfig";
import { fetchWithTimeout } from "../../../utils/fetchWithTimeout";

const profileImg = "/images/city3.jpg";
const avtImg = "/images/logo_benhvien_108.png";

class UserBox extends React.Component {
  constructor(props: any) {
    super(props);
    this.state = {
      active: false,
    };
  }

  handleLogout = async () => {
    const authClient = new AuthClient(appConfig.apiBaseUrl, {
      fetch: fetchWithTimeout(),
    });

    try {
      // Gọi API logout để xoá refresh_token cookie ở BE
      await authClient.postApiAuthAuthLogout();
    } catch (err) {
      console.error("Logout error:", err);
    } finally {
      tokenStore.clear();
      // Điều hướng về trang login admin
      window.location.href = "/login";
    }
  };

  render() {
    const { token } = tokenStore.get();
    const payload = token ? parseJwt(token) : null;

    return (
      <Fragment>
        <div className="header-btn-lg pe-0">
          <div className="widget-content p-0">
            <div className="widget-content-wrapper">
              <div className="widget-content-left">
                <UncontrolledButtonDropdown>
                  <DropdownToggle color="link" className="p-0">
                    <div className="flex items-center">
                      <img
                        width={42}
                        className="rounded-circle"
                        src={avtImg}
                        alt=""
                      />
                      <div className="widget-content-left  ms-3 header-user-info">
                        <div className="widget-heading">{payload?.email}</div>
                      </div>
                    </div>
                  </DropdownToggle>
                  <DropdownMenu className="rm-pointers dropdown-menu-lg ">
                    <div className="dropdown-menu-header">
                      <div className="dropdown-menu-header-inner bg-info">
                        <div
                          className="menu-header-image opacity-2"
                          style={{
                            backgroundImage: "url(" + profileImg + ")",
                          }}
                        />
                        <div className="menu-header-content text-start flex">
                          <div className="widget-content p-0">
                            <div className="widget-content-wrapper">
                              <div className="widget-content-left me-3 flex shrink-0">
                                <img
                                  width={42}
                                  className="rounded-circle"
                                  src={avtImg}
                                  alt=""
                                />
                              </div>
                              <div className="widget-content-left">
                                <div className="widget-heading">
                                  {payload?.email}
                                </div>
                                <div className="widget-subheading opacity-8">
                                  {payload?.departmentName}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="justify-end cursor-pointer relative z-10 me-2 flex shrink-0">
                          <Button
                            onClick={this.handleLogout}
                            className="btn-pill btn-shadow btn-shine"
                            color="focus"
                          >
                            Đăng xuất
                          </Button>
                        </div>
                      </div>
                    </div>
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default UserBox;
